export enum ModalId {
  Contact
}

export const ModalPriorities = {};
